const VISITOR_KEY = 'aoboshi.visitorId'
const SESSION_KEY = 'aoboshi.chatSessionId'

function tabValue(key: string, prefix: string) {
  const existing = sessionStorage.getItem(key)?.trim()
  if (existing) return existing
  const value = `${prefix}-${crypto.randomUUID()}`
  sessionStorage.setItem(key, value)
  return value
}

/**
 * Anonymous identities intentionally live in sessionStorage. A Learning
 * platform launch receives its own browsing context, so a student cannot
 * inherit the previous launch's learning profile on a shared device.
 */
export function visitorId() {
  return tabValue(VISITOR_KEY, 'guest')
}

export function chatSessionId() {
  return tabValue(SESSION_KEY, 'chat')
}

export function rotateChatSession() {
  const value = `chat-${crypto.randomUUID()}`
  sessionStorage.setItem(SESSION_KEY, value)
  return value
}

export function discardLegacySharedIdentity() {
  localStorage.removeItem('studentId')
  localStorage.removeItem('sessionId')
}
